import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import background from "../images/wux-background.png";
import "../styles/wux-delete.css";
import AuthService from "../service/wuxingren/auth-service";

const DeleteAccountComponent = () => {
  let [email, setEmail] = useState("");
  let [message, setMessage] = useState("");

  const handleChangeEmail = (e) => {
    setEmail(e.target.value);
  };

  const handleDelete = async () => {
    try {
      setMessage("");
      if (email) {
        try {
          let result = await AuthService.deleteAccount(email);
          setEmail("");
          setMessage("");
          alert("已刪除您的帳號！");
        } catch (e) {
          setEmail("");
          setMessage("");
          alert("帳號刪除失敗！");
        }
      } else {
        setMessage("尚未輸入您的信箱！");
      }
    } catch (e) {
      setMessage("帳號刪除失敗！");
    }
  };

  return (
    <div className="delete-wux-container">
      <img src={background} alt="背景" className="background" />
      <main>
        <div className="title">
          <img src="/images/ic-wux-logo.png" alt="Logo" />
        </div>
        <div className="delete-box">
          <div>
            <label for="exampleFormControlInput1" className="form-label">
              請輸入您要刪除的帳號信箱(Please Input Your Email To Delete)
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="name@example.com"
              value={email}
              onChange={handleChangeEmail}
            ></input>
            {message && <div className="alert alert-danger">{message}</div>}
          </div>

          <div className="delete">
            <button type="button" className="delete-btn" onClick={handleDelete}>
              刪除
            </button>
          </div>
        </div>
      </main>
      <footer>
        <p>Copyright © 2025 by Leinotek Co,.Ltd.</p>
      </footer>
      <ToastContainer /> {/* 確保這個容器存在 */}
    </div>
  );
};

export default DeleteAccountComponent;
